import React from "react";
import "../SolutionsSection.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaNetworkWired,
    FaCloud,
    FaUserShield,
    FaLaptopCode,
    FaArrowRight,
    FaShieldVirus,
    FaSearch,
    FaChartLine,
} from "react-icons/fa";

const solutions = [
    {
        icon: <FaNetworkWired />,
        title: "Network Security",
        description:
            "Protect enterprise networks with next-generation firewalls, intrusion prevention, VPN security, and real-time monitoring.",
    },
    {
        icon: <FaCloud />,
        title: "Cloud Security",
        description:
            "Secure AWS, Microsoft Azure, and Google Cloud environments with advanced cloud-native security solutions.",
    },
    {
        icon: <FaUserShield />,
        title: "Identity & Access Management",
        description:
            "Implement Zero Trust architecture, Multi-Factor Authentication, and privileged access management.",
    },
    {
        icon: <FaLaptopCode />,
        title: "Endpoint Protection",
        description:
            "Secure laptops, desktops, servers, and mobile devices against ransomware, malware, and advanced threats.",
    },
    {
        icon: <FaSearch />,
        title: "Vulnerability Assessment & Penetration Testing",
        description:
            "Identify vulnerabilities before attackers do through comprehensive security assessments and penetration testing.",
    },
    {
        icon: <FaShieldVirus />,
        title: "Security Operations Center",
        description:
            "24×7 threat monitoring, incident detection, security analytics, and rapid response through our SOC services.",
    },
    {
        icon: <FaChartLine />,
        title: "Governance, Risk & Compliance",
        description:
            "Achieve ISO 27001, GDPR, HIPAA, PCI-DSS, and other regulatory compliance with confidence.",
    },
    {
        icon: <FaNetworkWired />,
        title: "Incident Response",
        description:
            "Rapid containment, investigation, recovery, and business continuity planning after cyber incidents.",
    },
];

const SolutionsSection = () => {
    return (
        <section className="solutions-section">

            <div className="container">

                <motion.div
                    className="section-heading"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <span className="section-tag">
                        Our Solutions
                    </span>

                    <h2>
                        Comprehensive
                        <span> Cybersecurity Solutions</span>
                    </h2>

                    <p>
                        We help organizations strengthen their security posture with
                        end-to-end cybersecurity services designed to prevent attacks,
                        reduce risk, ensure compliance, and enable secure digital
                        transformation.
                    </p>

                </motion.div>

                <div className="solutions-grid">

                    {solutions.slice(0, 4).map((item, index) => (

                        <motion.div
                            key={index}
                            className="solution-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.5,
                                delay: index * 0.1,
                            }}
                        >

                            <div className="solution-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                            {/* <Link
                                to="/solutions"
                                className="solution-link"
                            >

                                Learn More

                                <FaArrowRight />

                            </Link> */}

                        </motion.div>

                    ))}

                    {solutions.slice(4).map((item, index) => (

                        <motion.div
                            key={index + 4}
                            className="solution-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.5,
                                delay: index * 0.1,
                            }}
                        >

                            <div className="solution-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                            {/* <Link
                                to="/solutions"
                                className="solution-link"
                            >

                                Learn More

                                <FaArrowRight />

                            </Link> */}

                        </motion.div>

                    ))}

                </div>

                {/* ===============================
            CTA SECTION
        =============================== */}

                <motion.div
                    className="solutions-cta"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <div className="cta-content">

                        <span className="cta-tag">
                            Secure • Detect • Respond
                        </span>

                        <h2>
                            Need a Custom Cybersecurity Strategy?
                        </h2>

                        <p>
                            Every organization has unique security challenges. Our
                            cybersecurity experts will assess your infrastructure,
                            identify risks, and design a tailored security strategy
                            that protects your business from evolving cyber threats.
                        </p>

                    </div>

                    <div className="cta-buttons">

                        <a
                            href="/consultation"
                            className="primary-btn"
                        >

                            Get Free Consultation

                            <FaArrowRight />

                        </a>

                        {/* <Link
                            to="/solutions"
                            className="secondary-btn"
                        >

                            Explore All Services

                        </Link> */}

                    </div>

                </motion.div>

            </div>

        </section>
    );
};

export default SolutionsSection;